export type BrandMetaVariant = "amber" | "violet" | "green" | "sky" | "slate";

export interface BrandMeta {
  initials: string;
  variant: BrandMetaVariant;
}

const BRAND_META: Record<string, BrandMeta> = {
  Lakme: { initials: "LK", variant: "amber" },
  "MG Motors": { initials: "MG", variant: "violet" },
  Himalaya: { initials: "HM", variant: "green" },
  Dove: { initials: "DV", variant: "sky" },
};

export function getBrandMeta(brand: string): BrandMeta {
  if (BRAND_META[brand]) {
    return BRAND_META[brand];
  }

  const words = brand.trim().split(/\s+/).filter(Boolean);
  const initials =
    words.length >= 2
      ? `${words[0][0] ?? ""}${words[1][0] ?? ""}`.toUpperCase()
      : brand.slice(0, 2).toUpperCase() || "BR";

  const variants: BrandMetaVariant[] = ["amber", "violet", "green", "sky", "slate"];
  const variant = variants[brand.length % variants.length] ?? "slate";

  return { initials, variant };
}
